import React from 'react';
import { StaffNotes } from './StaffNotesProvider';

export const StaffNotesContext = React.createContext<StaffNotes | null>(null);
